/* NTD first-order offer block. Maps (jar size, color set, pack) to a fixed-bundle variant and keeps prices,
   the "includes" line, the active form's variant id and the mobile sticky bar in sync. No dependencies.
   Each jar size has its own bundle product and its own form, so express checkout always buys the right one. */
(function () {
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  // Keep the last two words together so no line ends with a single orphan word.
  function nob(t) { var i = t.lastIndexOf(' '); return i > 0 ? t.slice(0, i) + '\u00a0' + t.slice(i + 1) : t; }
  function list(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    var dataEl = root.querySelector('[data-ntd-offer-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    data.variants = data.variants.filter(Boolean);
    var sizes = list(root, '.ntd-size__opt');
    var sets = list(root, '.ntd-set');
    var colors = list(root, '.ntd-color');
    var tiers = list(root, '.ntd-tier');
    var colorsWrap = root.querySelector('[data-colors]');
    var colorLabel = root.querySelector('[data-color-label]');
    var includes = root.querySelector('[data-includes]');
    var sticky = root.querySelector('[data-sticky]');
    var bump = data.bump ? root.querySelector('[data-bump]') : null;
    var bumpCheck = bump ? bump.querySelector('[data-bump-check]') : null;
    var bumpVariant = null;
    var forms = {};
    list(root, '[data-form-size]').forEach(function (w) {
      forms[w.dataset.formSize] = { wrap: w, form: w.querySelector('form'), input: w.querySelector('[data-variant-input]'), cta: w.querySelector('[data-cta]') };
    });
    // Galleries (snippets/ntd-offer-gallery.liquid): colour slides carry data-color; thumbs and dots are built here
    // from the visible slides so a set's gallery shows only that set's colours.
    var galleries = {};
    var lastView = null;
    list(root, '[data-gallery-size]').forEach(function (w) {
      var track = w.querySelector('[data-gallery-track]');
      var slides = list(w, '.ntd-gallery__slide');
      var thumbsWrap = w.querySelector('[data-gallery-thumbs]');
      var dotsWrap = w.querySelector('[data-gallery-dots]');
      var thumbs = slides.map(function (sl, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ntd-gallery__thumb';
        var img = sl.querySelector('img');
        b.setAttribute('aria-label', img && img.alt ? img.alt : 'Photo ' + (n + 1));
        if (img) { var t = document.createElement('img'); t.src = img.currentSrc || img.src; t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
        b.addEventListener('click', function () { g.go(g.visible.indexOf(sl), true); });
        thumbsWrap.appendChild(b);
        return b;
      });
      var g = { wrap: w, index: 0, visible: slides.slice(), dots: [] };
      g.mark = function (i) {
        g.index = i;
        slides.forEach(function (sl, n) { thumbs[n].setAttribute('aria-current', String(g.visible[i] === sl)); });
        g.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      };
      g.go = function (i, smooth) {
        var sl = g.visible[i];
        if (!sl) return;
        track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        g.mark(i);
      };
      g.filter = function (colors) {
        slides.forEach(function (sl, n) {
          var c = sl.dataset.color;
          var show = !c || !colors || colors.indexOf(c) > -1;
          sl.hidden = !show;
          thumbs[n].hidden = !show;
        });
        g.visible = slides.filter(function (sl) { return !sl.hidden; });
        dotsWrap.innerHTML = '';
        g.dots = g.visible.map(function () { var d = document.createElement('span'); d.className = 'ntd-gallery__dot'; dotsWrap.appendChild(d); return d; });
        thumbsWrap.hidden = dotsWrap.hidden = g.visible.length < 2;
      };
      g.goColor = function (name, smooth) {
        for (var i = 0; i < g.visible.length; i++) if (g.visible[i].dataset.color === name) { g.go(i, smooth); return true; }
        return false;
      };
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== g.index) g.mark(i);
        });
      }, { passive: true });
      g.filter(null);
      g.mark(0);
      galleries[w.dataset.gallerySize] = g;
    });
    var hex = {};
    colors.forEach(function (c) { hex[c.dataset.color] = c.dataset.hex; });

    var singleColors = colors.map(function (c) { return c.dataset.color; });
    var state = { size: forms[data.defaultSize] || galleries[data.defaultSize] ? data.defaultSize : 'wide', set: null, color: null, pack: data.defaultPack };
    var d = data.defaultColors;
    if (d.indexOf(data.singlePrefix) === 0 && singleColors.indexOf(d.slice(data.singlePrefix.length)) > -1) {
      state.set = 'single'; state.color = d.slice(data.singlePrefix.length);
    } else {
      state.set = d;
    }

    function sizeVariants(size) { size = size || state.size; return data.variants.filter(function (v) { return v.size === size; }); }
    function colorsValue() { return state.set === 'single' ? data.singlePrefix + state.color : state.set; }
    function find(cv, pack, size) {
      var vs = sizeVariants(size);
      for (var i = 0; i < vs.length; i++) if (vs[i].colors === cv && vs[i].pack === pack) return vs[i];
      return null;
    }
    function colorExists(name) { return sizeVariants().some(function (v) { return v.colors === data.singlePrefix + name; }); }
    function colorAvailable(name) { return sizeVariants().some(function (v) { return v.colors === data.singlePrefix + name && v.available; }); }
    function orderFor(btn) {
      var raw = state.size === 'regular' ? btn.dataset.orderRegular : btn.dataset.order;
      return (raw || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    function lidList(pack) {
      var n = parseInt(pack, 10);
      if (state.set === 'single') return [n + ' ' + state.color];
      var btn = sets.filter(function (b) { return b.dataset.set === state.set; })[0];
      var order = btn ? orderFor(btn).slice(0, n) : [];
      var counts = {}, seq = [];
      order.forEach(function (c) { if (!counts[c]) { counts[c] = 0; seq.push(c); } counts[c]++; });
      return seq.map(function (c) { return counts[c] > 1 ? counts[c] + ' ' + c : c; });
    }

    function render() {
      // Keep the chosen single color valid for this size.
      if (!state.color || !colorExists(state.color)) {
        state.color = singleColors.filter(colorAvailable)[0] || singleColors.filter(colorExists)[0] || singleColors[0];
      }
      var cv = colorsValue();
      var f = forms[state.size];
      Object.keys(forms).forEach(function (k) { forms[k].wrap.hidden = k !== state.size; });
      sizes.forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.size === state.size)); });

      sets.forEach(function (b) {
        b.setAttribute('aria-checked', String(b.dataset.set === state.set));
        if (b.dataset.set === 'single') return;
        var sw = b.querySelector('.ntd-set__swatches');
        sw.innerHTML = '';
        orderFor(b).slice(0, 6).forEach(function (name) {
          var s = document.createElement('span');
          s.className = 'ntd-swatch';
          s.style.setProperty('--swatch', hex[name] || '#ccc');
          sw.appendChild(s);
        });
      });
      colorsWrap.hidden = state.set !== 'single';
      colors.forEach(function (c) {
        c.hidden = !colorExists(c.dataset.color);
        c.setAttribute('aria-checked', String(c.dataset.color === state.color));
        c.classList.toggle('is-out', !colorAvailable(c.dataset.color));
      });
      if (colorLabel) colorLabel.textContent = 'Color: ' + state.color;

      // Galleries: the one for this size, filtered to the chosen set's colours; One color jumps to the picked colour.
      Object.keys(galleries).forEach(function (k) { galleries[k].wrap.hidden = k !== state.size; });
      var gal = galleries[state.size];
      if (gal) {
        var viewColors = singleColors.filter(colorExists);
        if (state.set !== 'single') {
          var sb = sets.filter(function (x) { return x.dataset.set === state.set; })[0];
          viewColors = sb ? orderFor(sb) : null;
        }
        var view = state.size + '|' + state.set + '|' + (state.set === 'single' ? state.color : '');
        if (view !== lastView) {
          var first = lastView === null;
          gal.filter(viewColors);
          if (first) gal.go(0, false);
          else if (state.set === 'single') { if (!gal.goColor(state.color, true)) gal.go(0, true); }
          else if (viewColors && viewColors.length) { if (!gal.goColor(viewColors[0], true)) gal.go(0, true); }
          else gal.go(0, true);
          lastView = view;
        }
      }

      tiers.forEach(function (t) {
        var v = find(cv, t.dataset.pack);
        t.setAttribute('aria-checked', String(t.dataset.pack === state.pack));
        t.classList.toggle('is-out', !v || !v.available);
        var lids = parseInt(t.dataset.lids, 10) || 1;
        t.querySelector('[data-price]').textContent = v ? money(v.price, data.moneyFormat) : '';
        t.querySelector('[data-was]').textContent = v && v.compare > v.price ? money(v.compare, data.moneyFormat) : '';
        t.querySelector('[data-per]').textContent = v ? money(Math.round(v.price / lids), data.moneyFormat) + ' per lid' : '';
      });

      var chosen = find(cv, state.pack);
      var gifts = data.gifts[state.pack] || 0;
      includes.textContent = nob('Includes ' + lidList(state.pack).join(', ') + ' ' + (data.sizeWords[state.size] || '') + ' drink lids' +
        (gifts ? ' + ' + (gifts > 1 ? gifts + ' free ' + data.giftName + 's' : '1 free ' + data.giftName) : '') + '.');

      var bumpOn = false;
      // Other-size add-on: the same colors in the other size when that exists, else the default set.
      if (bump) {
        var other = state.size === 'wide' ? 'regular' : 'wide';
        var bv = find(cv, data.bump.pack, other);
        if (!bv || !bv.available) bv = find(data.defaultColors, data.bump.pack, other);
        bumpVariant = bv && bv.available && data.sizeTitles[other] ? bv : null;
        bump.hidden = !bumpVariant;
        if (bumpVariant) {
          bump.querySelector('[data-bump-title]').textContent = data.bump.title.replace('{product}', data.sizeTitles[other]).replace(/(\d) Pack/g, '$1\u00a0Pack');
          bump.querySelector('[data-bump-note]').textContent = nob(data.bump.note.replace('{colors}', bumpVariant.colors));
          bump.querySelector('[data-bump-was]').textContent = money(bumpVariant.price, data.moneyFormat);
          bump.querySelector('[data-bump-price]').textContent = money(bumpVariant.price - data.bump.off, data.moneyFormat);
        }
        bumpOn = !!(bumpVariant && bumpCheck.checked);
        bump.classList.toggle('is-on', bumpOn);
        // Shopify's express button only buys the form's pack, so while the add-on is ticked it is swapped for a
        // Shop Pay cart link that carries both packs (/cart/<pack>:1,<add-on>:1?payment=shop_pay).
        Object.keys(forms).forEach(function (k) {
          var ex = forms[k].wrap.querySelector('.ntd-offer__express');
          var sp = forms[k].wrap.querySelector('[data-shoppay]');
          if (ex) ex.hidden = bumpOn;
          if (sp) {
            sp.hidden = !bumpOn;
            if (bumpOn) sp.href = '/cart/' + forms[k].input.value + ':1,' + bumpVariant.id + ':1?payment=shop_pay';
          }
        });
      }

      var ok = chosen && chosen.available;
      if (chosen && f) f.input.value = chosen.id;
      if (f) {
        f.cta.disabled = !ok;
        var total = ok ? chosen.price + (bumpOn ? bumpVariant.price - data.bump.off : 0) : 0;
        f.cta.textContent = ok ? data.ctaLabel + ' · ' + money(total, data.moneyFormat) : data.soldOut;
      }
      if (sticky && !data.amazon) { // Amazon mode (2026-10-01): the bar is a plain link to the Amazon store
        sticky.querySelector('[data-sticky-name]').textContent = state.pack + ', ' + (state.set === 'single' ? state.color : state.set);
        sticky.querySelector('[data-sticky-price]').textContent = chosen ? money(chosen.price + (bumpOn ? bumpVariant.price - data.bump.off : 0), data.moneyFormat) : '';
        var sb = sticky.querySelector('[data-sticky-btn]');
        if (f) sb.setAttribute('form', f.form.getAttribute('id')); // not f.form.id: the hidden <input name="id"> shadows it
        sb.disabled = !ok;
      }
    }

    sizes.forEach(function (b) { b.addEventListener('click', function () { state.size = b.dataset.size; render(); }); });
    if (bumpCheck) bumpCheck.addEventListener('change', render);

    // Add To Cart (Skylar 2026-09-27): adds the chosen pack (plus the add-on if ticked) and opens Dawn's cart drawer,
    // so shoppers can add more or remove a pack before checkout. With go_to_checkout on (the old Buy Now), the cart
    // is replaced by exactly what's picked and the shopper goes straight to checkout, since checkout can't remove lines.
    var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function post(path, body) {
      return fetch(root_ + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (res) { if (!res.ok) throw new Error(path + ' failed'); return res; });
    }
    Object.keys(forms).forEach(function (k) {
      var f = forms[k];
      f.form.addEventListener('submit', function (e) {
        if (k !== state.size) return;
        var withBump = bumpCheck && bumpCheck.checked && bumpVariant;
        var drawer = document.querySelector('cart-drawer');
        if (!data.toCheckout && !withBump && !drawer) return;
        e.preventDefault();
        f.cta.disabled = true;
        var items = [{ id: Number(f.input.value), quantity: 1 }];
        if (withBump) items.push({ id: bumpVariant.id, quantity: 1 });
        var body = { items: items };
        if (!data.toCheckout && drawer) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        (data.toCheckout ? post('cart/clear.js') : Promise.resolve())
          .then(function () { return post('cart/add.js', body); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (data.toCheckout) { window.location.href = root_ + 'checkout'; return; }
            if (!drawer || !cart.sections) { window.location.href = root_ + 'cart'; return; }
            cart.id = items[0].id;
            drawer.classList.remove('is-empty'); // as Dawn's product-form does; otherwise focus trapping fails on first add
            drawer.renderContents(cart);
            f.cta.disabled = false;
          })
          .catch(function () {
            f.cta.disabled = false;
            f.form.submit(); // fall back to the plain form post (the pack alone)
          });
      });
    });
    sets.forEach(function (b) { b.addEventListener('click', function () { state.set = b.dataset.set; render(); }); });
    colors.forEach(function (c) { c.addEventListener('click', function () { state.color = c.dataset.color; render(); }); });
    tiers.forEach(function (t) { t.addEventListener('click', function () { state.pack = t.dataset.pack; render(); }); });

    // Sticky bar (phones and desktop): on screen whenever the offer panel isn't. Below the offer it adds the chosen
    // pack; above it (e.g. the landing page hero) it scrolls to the offer instead (Skylar 2026-09-25: always a CTA).
    if (sticky && 'IntersectionObserver' in window) {
      var panel = root.querySelector('.ntd-offer__panel');
      var sbtn = sticky.querySelector('[data-sticky-btn]');
      var stickyLabel = sbtn.textContent;
      sbtn.addEventListener('click', function (e) {
        if (!data.amazon && sticky.dataset.mode === 'ahead') { e.preventDefault(); root.scrollIntoView({ behavior: 'smooth' }); }
      });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var off = !e.isIntersecting;
          sticky.dataset.mode = off && e.boundingClientRect.top > 0 ? 'ahead' : 'past';
          sticky.classList.toggle('is-visible', off);
          // Below the offer the bar buys the chosen pack (Buy Now); above it, it only scrolls to the offer (Shop Now).
          if (!data.amazon) sbtn.textContent = sticky.dataset.mode === 'past' && data.ctaLabel ? data.ctaLabel : stickyLabel;
          sticky.setAttribute('aria-hidden', String(!off));
          sbtn.tabIndex = off ? 0 : -1;
          // The Klaviyo teaser rides on top of the bar (rule in sections/ntd-sticky-cta.liquid).
          document.documentElement.style.setProperty('--ntd-bar-h', off && window.innerWidth < 990 ? sticky.offsetHeight + 'px' : '0px');
        });
      }).observe(panel);
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-ntd-offer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-ntd-offer]'); if (r) init(r);
  });
})();
